<script setup>
import Card from 'primevue/card';

defineOptions({
  name: 'Card',
});

const props = defineProps({
  bordered: Boolean,
});

const passThrough = {};

if (props.bordered) {
  passThrough.root = {
    class: 'tw-shadow-none tw-border',
  };
}
</script>

<template>
  <Card :pt="passThrough">
    <template v-for="(_, name) in $slots" v-slot:[name]="slotData">
      <slot :name="name" v-bind="slotData" />
    </template>
  </Card>
</template>

<style scoped>
:deep(.p-card-body) {
  padding: 1.25rem;
}
</style>
